import React from 'react';
import { useSelector } from 'react-redux';
import { Content, Panel } from 'rsuite';
import PageHeader from '../../../../components/PageHeader';
import PageLayout from '../../../../components/reservations/PageLayout';
import ContentLoader from '../../../../components/ContentLoader';
import ResultHeader from './ResultHeader';
import GuestSummaryList from '../../../../components/reservations/reports/OrderedItemsList';
import OrderedItemsSearchForm from '../../../../components/reservations/reports/OrderedItemsSearchForm';
import {
  getIsFetched,
  getIsFetching
} from '../../../../redux/Reservation/selectors/reports/ordered-items';

export default () => {
  const isFetched = useSelector(getIsFetched);
  const isFetching = useSelector(getIsFetching);
  return (
    <PageLayout>
      <PageHeader title="Ordered Items Report">
        <OrderedItemsSearchForm />
      </PageHeader>
      <Content>
        {isFetching && <ContentLoader />}
        {isFetched && (
          <Panel bodyFill bordered header={<ResultHeader />}>
            <GuestSummaryList />
          </Panel>
        )}
      </Content>
    </PageLayout>
  );
};
